// This mixin contains code that is used for only electric commercial configs
import Vue from "vue";
import moment from "moment";
import { _ } from "underscore";

export default {
  data() {
    return {
      elecConfigTemplate: {
        ApplicationRule: "Always",
        BillingEac: [],
        CcaAgreementDescription: null,
        CcaReductionPercentage:
          Vue.config.honeycomb.commercialConfig.ccaReductionPercentage,
        CclExemptionType: "NotExempt",
        CommercialPercentage:
          Vue.config.honeycomb.commercialConfig.commercialPercentage,
        EacLevel: "MeterPoint",
        MeterPointBillingEac: null,
      },
    }
  },
  computed: {
    currentMeters() {
      if (!this.activeCommercialConfig || this.activeServiceType === 'Gas') return null;
      let effectiveFrom = this.activeCommercialConfig.EffectiveFrom;
      let effectiveTo = this.activeCommercialConfig.hasOwnProperty(
        "EffectiveTo"
      )
        ? this.activeCommercialConfig.EffectiveTo
        : moment();

      return _.filter(this.$store.state.meters.activeService.Meters, meter => {
        let removed = meter.hasOwnProperty("Removed")
          ? meter.Removed
          : moment();
        return (
          moment(removed).isSameOrAfter(effectiveFrom) &&
          moment(meter.Installed).isSameOrBefore(effectiveTo)
        );
      });
    },
    currentMeterConfigs() {
      if (!this.currentMeters) return null;
      let effectiveFrom = this.activeCommercialConfig.EffectiveFrom;
      let effectiveTo = this.activeCommercialConfig.hasOwnProperty(
        "EffectiveTo"
      )
        ? this.activeCommercialConfig.EffectiveTo
        : moment();

      return _.filter(
        _.flatten(_.pluck(this.currentMeters, "MeterConfigs")),
        config => {
          let configEffectiveTo = config.hasOwnProperty("EffectiveTo")
            ? config.EffectiveTo
            : moment();
          return (
            moment(configEffectiveTo).isSameOrAfter(effectiveFrom) &&
            moment(config.EffectiveFrom).isSameOrBefore(effectiveTo)
          );
        }
      );
    },
    currentRegisters() {
      if (!this.currentMeterConfigs) return null;
      return _.filter(
        _.uniq(
          _.map(
            _.flatten(_.pluck(this.currentMeterConfigs, "Registers")),
            config => {
              return {
                BillingTypeId: config.BillingTypeId,
                RegisterId: config.RegisterId
              };
            }
          ),
          "RegisterId"
        ),
        register => {
          return register.BillingTypeId != "NotApplicable";
        }
      );
    },
    isHH() {
      return this.$store.state.meters.activeService.MeterPoint.MeterPointConfigs.some(g => g.MeasurementMethod === 'HalfHourly')
    },
    HHNHHMappings() {
      return this.$store.state.contracts.hhnhhmappings;
    },

    mappingInvalid() {
      return (
        this.isHH
        && !this.activeServiceBundle.Products.some(p => p.PriceingApproch == "ElecHh")
        && this.configCopy
        && this.configCopy.HhNhhMappingId === undefined)
    },

    activeServiceBundle() {
      return this.$store.state.contracts.serviceBundles.find(sb => sb.Id === _.sortBy(this.activeContract.ServiceBundles, 'EffectiveFrom').reverse()[0].ServiceBundleId)
    }
  },
  methods: {
    createBillingEacObject() {
      return _.map(this.currentRegisters, register => {
        return {
          RegisterId: register.RegisterId,
          BillingEac: 0
        };
      });
    },
    getBillingTypeId(registerId) {
      return _.findWhere(this.currentRegisters, { RegisterId: registerId })
        .BillingTypeId;
    },
    getMeterPointBillingEac(config) {
      let eac = 0;
      config.BillingEac.forEach(billingEac => {
        eac += parseInt(billingEac.BillingEac);
      });
      return eac;
    },
    updateBillingEacs(config) {
      if (config.MeterPointBillingEac == null) {
        config.BillingEac.forEach(eac => {
          eac.BillingEac = null;
        });
        return;
      }

      let remainder = config.MeterPointBillingEac % config.BillingEac.length;
      let averageEac = Math.trunc(
        config.MeterPointBillingEac / config.BillingEac.length
      );
      config.BillingEac.forEach(eac => {
        eac.BillingEac = averageEac;
      });
      for (let i = 0; i < remainder; i++) {
        config.BillingEac[i].BillingEac += 1;
      }
    },
  }
}